module.exports = __webpack_public_path__ + "static/media/miscellaneous_services-24px.9e1cf411.svg";